import React, { useEffect } from 'react';
import { Box, List, ListItemButton, ListItemText, Chip } from '@mui/material';
import { useReviewUpdatesContext } from '../context';
import datetimeHelper from 'helpers/datetimeHelper';
import { neutral } from '_lex/_foundations/phxColors';
import { translate as t } from 'hooks/useTranslations';
import _ from 'lodash';
import Loading from 'views/App/Portal/Loading';

const ReviewDrawerUpdates: React.FC = () => {
  const { focus, setFocus, policyUpdates, prefaceUpdates, sidebarItems, pendingUpdatesQuery } =
    useReviewUpdatesContext();

  const handleItemClick = (id: string) => {
    setFocus(id);
  };

  useEffect(() => {
    if (sidebarItems.length === 0 && !!focus) {
      setFocus(null);
    }
  }, [sidebarItems, focus, setFocus]);

  const isNewSection = (id: string) => {
    if (policyUpdates?.sections) {
      const section = policyUpdates.sections.find((s) => s.id === id);
      return section?.isNew;
    }
    return false;
  };

  return pendingUpdatesQuery.isLoading || pendingUpdatesQuery.isFetching ? (
    <Loading />
  ) : (
    <Box>
      <List sx={{ p: 0 }}>
        {sidebarItems.map((item) => (
          <ListItemButton
            key={item.id}
            selected={focus === item.id}
            onClick={() => handleItemClick(item.id)}
            sx={{
              borderBottom: '1px solid #ccc',
              '&.Mui-selected': {
                backgroundColor: neutral[100],
                '&:hover': {
                  backgroundColor: neutral[200],
                },
              },
            }}
          >
            <ListItemText
              sx={{ padding: 2, textWrap: 'auto' }}
              primary={
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  {item.title}
                  {isNewSection(item.id) && (
                    <Chip
                      label={t('draftManuals.toc.new')}
                      color='primary'
                      size='small'
                    />
                  )}
                </Box>
              }
              secondary={datetimeHelper.formatDateTime(item.changeDate, {
                format: 'monthDayYearTime',
                missingDisplay: '',
              })}
              primaryTypographyProps={{
                sx: { marginBottom: 2, fontSize: '16px' },
              }}
            />
          </ListItemButton>
        ))}
      </List>
    </Box>
  );
};

export default ReviewDrawerUpdates;
